import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import HeroSection from "./components/HeroSection/HeroSection";
import AboutSection from "./components/AboutSection/AboutSection";
import FeaturesSection from "./components/FeaturesSection/FeaturesSection";
import JoinSection from "./components/JoinSection/JoinSection";
import Footer from "./components/Footer/Footer";
import Copyrights from "./components/Footer/Copyrights"; // ✅ add this
import "./App.css";
import PrivacyPolicy from './components/Footer/PrivacyPolicy'
import EndUserLicenseAgreement from "./components/Footer/EndUserLicenseAgreement";
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home page */}
          <Route
            path="/"
            element={
              <>
                {/* <Header /> */}
                <HeroSection />
                <AboutSection />
                <FeaturesSection />
                <JoinSection />
                <Footer />
              </>
            }
          />

          {/* Privacy Policy page */}
          <Route path="/privacy-Policy" element={<PrivacyPolicy />} />
           <Route path="/termsandconditions" element={< Copyrights/>} />
           <Route path="/eula" element={< EndUserLicenseAgreement/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
